var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', {
    staticClass: "ma-ne"
  }, [_c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('digikey-credentials', _vm._g(_vm._b({}, 'digikey-credentials', {
    value: _vm.value
  }, false), {
    input: _vm.input
  }))], 1), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('digikey-headers', _vm._g(_vm._b({}, 'digikey-headers', {
    value: _vm.value
  }, false), {
    input: _vm.input
  }))], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }